import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { IConfirmationDialog } from "../models/confirmation-dialog";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";

@Injectable({ providedIn: "root" })
export class ConfirmationDialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(
    data: IConfirmationDialog,
  ): MatDialogRef<ConfirmationDialogComponent> {
    return this.dialog.open(ConfirmationDialogComponent, {
      data: data,
      width: "400px",
      height: "200px",
      panelClass: "noBackground",
      autoFocus: false,
    });
  }

  removeConfirmationDialog(message: string) {
    return this.openDialog({
      title: "htDelete",
      message,
      btnText: "base.delete",
      btnIcon: "icon-busket",
      btnType: "danger",
    });
  }
}
